import React, {useState} from "react";
import {CreateEntityModal} from "../CreateEntityModal";
import {ListBlock} from "./ListBlock";
import {SideItemRow} from "./SideItemRow";

export const EntityBlock = ({project, onUpdateProject, getUserProjects, flow}) => {
    const [openModal, setOpenModal] = useState(false);
    const [selectedEntity, setSelectedEntity] = useState(null);
    const [search, setSearch] = useState("");

    const onUpdateEntity = async (entity) => {
        const newProject = {...project};
        const index = newProject?.entities?.findIndex((i) => i?.id === entity?.id);
        if (isFinite(index) && index >= 0) {
            newProject.entities[index] = entity;
        } else {
            newProject.entities.push(entity);
        }
        await onUpdateProject(newProject);
        await getUserProjects();
    };

    const onRemove = async (id) => {
        const newProject = {...project};
        newProject.entities = newProject?.entities?.filter((item) => item.id !== id);
        await onUpdateProject(newProject);
        await getUserProjects();
    };

    const items = project?.entities?.filter(
        (item) => item?.name?.toLowerCase()?.includes(search?.toLowerCase()),
    ) || [];

    return (
        <>
            <CreateEntityModal
                flow={flow}
                open={openModal}
                handleClose={() => {
                    setOpenModal(false);
                    setSelectedEntity(null);
                }}
                entity={selectedEntity}
                handleSubmit={onUpdateEntity}
                onRemove={onRemove}
            />
            <ListBlock
                title="Entities"
                items={items}
                search={search}
                onChangeSearch={setSearch}
                onCreate={() => setOpenModal(true)}
                mapItem={(entity) => (
                    <SideItemRow
                        key={entity?.id || entity?.key}
                        label={entity?.name}
                        tooltip={entity?.name}
                        onClick={() => {
                            setSelectedEntity(entity);
                            setOpenModal(true);
                        }}
                    />
                )}
            />
        </>
    );
};
